export const getPreviousYearDate = (date) => {
  const previousYearDate = new Date(date);
  previousYearDate.setUTCFullYear(date.getUTCFullYear() - 1);
  return previousYearDate.toISOString();
};
